import React from 'react';
import { PlanName, UnitName } from '../../models';
import { useModuleProps } from '../../module-props';
import { FormatMessage } from '@atlassiansox/bxp-ui-sdk';

export const GetMaxUsersMessage = (
  unitName: UnitName,
  localeISOCode: string,
  selectedPlanName: PlanName,
  maxUnits: number
) => {
  const { isMaxForLabel, usersLabel, agentsLabel, creatorsLabel, planLabel } =
    useModuleProps();
  switch (unitName) {
    case 'USER':
      return `${Intl.NumberFormat(localeISOCode).format(
        maxUnits
      )} ${usersLabel} ${isMaxForLabel} ${selectedPlanName} ${planLabel.toLocaleLowerCase()}.`;
    case 'AGENT':
      return `${Intl.NumberFormat(localeISOCode).format(
        maxUnits
      )} ${agentsLabel} ${isMaxForLabel} ${selectedPlanName} ${planLabel.toLocaleLowerCase()}.`;
    case 'CREATOR':
      return `${Intl.NumberFormat(localeISOCode).format(
        maxUnits
      )} ${creatorsLabel} ${isMaxForLabel} ${selectedPlanName} ${planLabel.toLocaleLowerCase()}.`;
  }
};

export const GetMinUsersMessage = (
  unitName: UnitName,
  localeISOCode: string,
  selectedPlanName: PlanName,
  minUnits: number
) => {
  const { minUsersLabel, usersLabel, agentsLabel, creatorsLabel, planLabel } =
    useModuleProps();

  switch (unitName) {
    case 'USER':
      return (
        <FormatMessage
          message={minUsersLabel}
          values={{
            minUnits: `${Intl.NumberFormat(localeISOCode).format(minUnits)}`,
            unitsLabel: `${usersLabel}`,
            selectedPlanName: `${selectedPlanName}`,
            planLabel: `${planLabel.toLocaleLowerCase()}`
          }}
        />
      );
    case 'AGENT':
      return (
        <FormatMessage
          message={minUsersLabel}
          values={{
            minUnits: `${Intl.NumberFormat(localeISOCode).format(minUnits)}`,
            unitsLabel: `${agentsLabel}`,
            selectedPlanName: `${selectedPlanName}`,
            planLabel: `${planLabel.toLocaleLowerCase()}`
          }}
        />
      );
    case 'CREATOR':
      return (
        <FormatMessage
          message={minUsersLabel}
          values={{
            minUnits: `${Intl.NumberFormat(localeISOCode).format(minUnits)}`,
            unitsLabel: `${creatorsLabel}`,
            selectedPlanName: `${selectedPlanName}`,
            planLabel: `${planLabel.toLocaleLowerCase()}`
          }}
        />
      );
  }
};

export const GetEnterpriseAnnualOnlyMessage = (selectedPlanName: PlanName) => {
  const { enterpriseAnnualOnlyLabel } = useModuleProps();
  return (
    <FormatMessage
      message={enterpriseAnnualOnlyLabel}
      values={{
        selectedPlanName: `${selectedPlanName}`
      }}
    />
  );
};

export const GetEnterpriseMessage = (
  unitName: UnitName,
  minEnterpriseUnits: number
) => {
  const {
    enterprisePlanPricingUsersLabel,
    enterprisePlanPricingAgentsLabel,
    enterprisePlanPricingCreatorsLabel
  } = useModuleProps();
  switch (unitName) {
    case 'USER':
      return (
        <FormatMessage
          message={enterprisePlanPricingUsersLabel}
          values={{
            minEnterpriseUnits: `${minEnterpriseUnits}`
          }}
        />
      );
    case 'AGENT':
      return (
        <FormatMessage
          message={enterprisePlanPricingAgentsLabel}
          values={{
            minEnterpriseUnits: `${minEnterpriseUnits}`
          }}
        />
      );
    case 'CREATOR':
      return (
        <FormatMessage
          message={enterprisePlanPricingCreatorsLabel}
          values={{
            minEnterpriseUnits: `${minEnterpriseUnits}`
          }}
        />
      );
  }
};

export const GetContactMessage = (unitName: UnitName) => {
  const {
    contactSalesTeamLabel,
    aboutOptionsLabel,
    usersLabel,
    agentsLabel,
    creatorsLabel
  } = useModuleProps();
  switch (unitName) {
    case 'USER':
      return (
        <React.Fragment>
          <a href="https://www.atlassian.com/enterprise/contact?formType=pricing-quotes">
            {contactSalesTeamLabel}
          </a>{' '}
          {aboutOptionsLabel} {usersLabel}
        </React.Fragment>
      );
    case 'AGENT':
      return (
        <React.Fragment>
          <a href="https://www.atlassian.com/enterprise/contact?formType=pricing-quotes">
            {contactSalesTeamLabel}
          </a>{' '}
          {aboutOptionsLabel} {agentsLabel}
        </React.Fragment>
      );
    case 'CREATOR':
      return (
        <React.Fragment>
          <a href="https://www.atlassian.com/enterprise/contact?formType=pricing-quotes">
            {contactSalesTeamLabel}
          </a>{' '}
          {aboutOptionsLabel} {creatorsLabel}
        </React.Fragment>
      );
  }
};

export const GetUnitPriceMessage = (unitName: UnitName) => {
  const { perUserTypeLabel, perAgentTypeLabel, perCreatorTypeLabel } =
    useModuleProps();
  switch (unitName) {
    case 'USER':
      return ` ${perUserTypeLabel}`;
    case 'AGENT':
      return ` ${perAgentTypeLabel}`;
    case 'CREATOR':
      return `${perCreatorTypeLabel}`;
  }
};

export const GetTierMessage = (unitName: UnitName) => {
  const { userTierLabel, agentTierLabel, creatorsTierLabel } = useModuleProps();
  switch (unitName) {
    case 'USER':
      return `${userTierLabel} `;
    case 'AGENT':
      return `${agentTierLabel} `;
    case 'CREATOR':
      return `${creatorsTierLabel} `;
  }
};

export const GetInputLabel = (unitName: UnitName) => {
  const { numberOfLabel, usersLabel, agentsLabel, creatorsLabel } =
    useModuleProps();
  switch (unitName) {
    case 'USER':
      return `${numberOfLabel} ${usersLabel}`;
    case 'AGENT':
      return `${numberOfLabel} ${agentsLabel}`;
    case 'CREATOR':
      return `${numberOfLabel} ${creatorsLabel}`;
  }
};

export const GetUserTypeLabel = (unitName: UnitName) => {
  const { usersLabel, agentsLabel, creatorsLabel } = useModuleProps();
  switch (unitName) {
    case 'USER':
      return usersLabel;
    case 'AGENT':
      return agentsLabel;
    case 'CREATOR':
      return creatorsLabel;
  }
};
